export function pixels(value) {
  return `${value}px`;
}
